<template>
  <div class="industry_right">
    <p class="company_common_title">
      <span>{{industryTitle}}</span>
    </p>

    <!-- search result -->
    <div class="downContainer">
      <title-temp title="Search results"></title-temp>
      <table-list :column="currentColumn" :tableData="currentData" :column200="true"></table-list>
    </div>

    <!-- Chart display -->
    <div class="chart-contai" v-if="refushChart">
      <title-temp title="Chart display"></title-temp>
      <line-chart :xData="xData" :serData="serData"></line-chart>
    </div>
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import TableList from "common/components/table";
import LineChart from "../../BarLine";
import column from "conf/industryColumn";
import { getIndictorsData } from "common/js/http/v2Api";
const color = [
  "#836FFF",
  "#71C671",
  "#5E71FF",
  "#86C1FF",
  "#7583EA",
  "#FFC962",
  "#BCD2EE",
  "#A2B5CD",
  "#FFC125",
  "#757575"
];

export default {
  props: ["conditions"],

  components: {
    TitleTemp,
    TableList,
    LineChart
  },

  data() {
    return {
      industryTitle: "Industry search index",
      currentColumn: column,
      currentData: [],
      xData: [],
      serData: [],
      refushChart: true
    };
  },

  created() {
    this.searchResult(this.conditions);
  },

  methods: {
    async searchResult(id) {
      const indictors = [
        {
          id: id
        }
      ];
      const params = {
        indictors
      };
      if (!params.indictors.length) return;

      const { result } = await getIndictorsData(params);
      // this.creatWorkerConverTable(result);
      setTimeout(() => {
        this.converTableData(result);
      }, 0);
      setTimeout(() => {
        this.converChartData(result);
      }, 0);
    },

    // converTest(val) {
    //   //v-show
    //   this.conditions = val.conditions;
    //   console.log("converTableData -> result1", result1)
    // },

    //行业 顺序是升序 需要reverse table
    converTableData(result1) {
      console.log("TCL: converTableData -> result1", result1);
      // console.log(this.$moment("2019-12-24T19:05:44.000+0000").format("YYYY-MM-DD"))
      const result = this.$lodash.cloneDeep(result1);

      const columnCf = this.$lodash.cloneDeep(column);
      const data = result.map(item => {
        const itemData = {
          name: item.name,
          location: item.location,
          time: item.time,
          unit: item.unit,
          resource: item.resource
        };
        item.data.reverse().forEach(i => {
          const dateKey = this.$moment(i.moditime).format('YYYY-MM-DD');
					columnCf.push({
						label: dateKey,
						field: dateKey
					});
					itemData[dateKey] = i.value;
        });
        return itemData;
      });
      // 设置列
      this.currentColumn = columnCf;
      console.log("TCL: converTableData -> this.currentColumn", this.currentColumn)
      this.currentData = data;
    },

    converChartData(result1) {
      const result = this.$lodash.cloneDeep(result1);

      const data = result.map((item, index) => {
        const x_data = [];
        const itemData = {
          name: item.name,
          type: "line",
          // stack: "dta",
          data: [],
          unit: item.unit,
          smooth: true,
          itemStyle: {
            normal: {
              color: color[index % 10], //改变折线点的颜色
              lineStyle: {
                color: color[index % 10] //改变折线颜色
              }
            }
          }
        };
        item.data.forEach(i => {
					const dateKey = this.$moment(i.moditime).format('YYYY-MM-DD');
					x_data.push(dateKey);
					itemData.data.push(i.value || 0);
				});
        this.xData = x_data;
        return itemData;
      });
      const isLength = data.filter(item => item.data.length);
      this.serData = isLength.length ? data : [];

      // class A{
      //   constructor() {
      //     this.a = "123"
      //   }
      // }
    }
  },

  watch: {
    refush(newValue) {
      // console.log("TCL: refush -> newValue", newValue);
      // this.refushChart = false;
      // this.$nextTick(() => {
      //   this.refushChart = true;
      // });
    }
  }
};
</script>

<style scoped>
.industry_right {
  height: 100%;
  padding: 10px;
  background: #fff;
}
.tag_list span {
  border: 1px solid #e2e3e4;
  border-radius: 15.5px;
  /* padding: 5px 10px; */
  margin-right: 10px;
  margin-bottom: 10px;
}
.tag_list {
  border: 1px solid #f3f4f5;
  height: 200px;
  overflow: auto;
  padding: 10px;
}
.btnContainer {
  text-align: right;
  margin-top: 20px;
}
.chart-contai >>> .el-date-editor .el-range-separator {
  line-height: 25px;
}
.chart-contai >>> .el-date-editor .el-range__close-icon {
  line-height: 27px;
}
.downContainer {
  position: relative;
}
.downLoadBtn {
  position: absolute;
  right: 0px;
}
</style>